import { Checkbox } from './Checkbox';
import { Label } from './Label';
import { MultiSearchSelect } from './MultiSearchSelect';
import { MultiselectTypeAhead } from './MultiselectTypeAhead';
import { NumberToggle } from './NumberToggle';
import { PasswordStrengthIndicator } from './PasswordStrengthIndicator';
import { PhoneNumber } from './PhoneNumber';
import { Radios } from './Radios';
import { SearchSelect } from './SearchSelect';
import { Select } from './Select';
import { SingleDateSelect } from './SingleDateSelect';
import { Slider } from './Slider';
import { Spacer } from './Spacer';
import { Switch } from './Switch';
import { TextEditor } from './TextEditor';
import { TextInput } from './TextInput';
import { TwoFactorAuthentication } from './TwoFactorAuthentication';

const FormElements = {
  Checkbox,
  Label,
  MultiSearchSelect,
  MultiselectTypeAhead,
  NumberToggle,
  PasswordStrengthIndicator,
  PhoneNumber,
  Radios,
  SearchSelect,
  Select,
  SingleDateSelect,
  Slider,
  Spacer,
  Switch,
  TextEditor,
  TextInput,
  TwoFactorAuthentication
};

export default FormElements;
